import { render, staticRenderFns } from "./EvolucionUci.vue?vue&type=template&id=57cb4ba7&scoped=true"
import script from "./EvolucionUci.vue?vue&type=script&lang=js"
export * from "./EvolucionUci.vue?vue&type=script&lang=js"
import style0 from "./EvolucionUci.vue?vue&type=style&index=0&id=57cb4ba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb4ba7",
  null
  
)

export default component.exports